import {Component} from "react";
import "../style/NavbarStyles.css";
import { MenuItems } from "./NavbarItems";
import {Link} from "react-router-dom"

class Navbar extends Component{
    state = {clicked: false};
    handleClick = () =>{
        this.setState({clicked: !this.state.clicked})
    }

    render(){
        return(
            <nav className="NavbarItems">
                <Link to="/">
                    <h1 className="navbar-logo">Queen's Nails</h1>
                </Link>

                <div className="menu-icons" onClick={this.handleClick}>
                    <i className={this.state.clicked ? "fas fa-times": "fas fa-bars"}></i>
                </div>                <ul className={this.state.clicked ? "nav-menu active" : "nav-menu"}>
                    {MenuItems.map((item,index) =>{
                        return(
                            <li key={index}>
                                {item.external ? (
                                    <a className={item.cName} href={item.url} target="_blank" rel="noopener noreferrer">
                                        <i className={item.icon}></i>
                                        {item.title}
                                    </a>
                                ) : (
                                    <Link className={item.cName} to={item.url}>
                                        <i className={item.icon}></i>
                                        {item.title}
                                    </Link>
                                )}
                            </li>
                        )
                    })}
                </ul>
                
                <div className="nav-button">
                    {/** 
                     * <a href="https://cal.com/thu-ngo-d3bs7h" target="_blank" rel="noopener noreferrer">
                        <button>Book Now</button>
                    </a>
                    */}
                    <a href="/booking" rel="noopener noreferrer">
                        <button>Book Now</button>
                    </a>
                    
                </div>
            </nav>   
        )
    }
}

export default Navbar;